export default __webpack_public_path__ + "static/media/bx_bxs-key.bb8384fc.svg";